module.exports = __webpack_public_path__ + "static/media/Tile Image 4.05ae118e.png";